import React, { useState } from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Mail, Phone, MapPin, CheckCircle } from 'lucide-react';
export function Kontakt() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="pb-20" data-id="element-269">
      <section className="pt-20 pb-16 bg-[#0f0f16]" data-id="element-270">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-271">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-272">
            Kontaktieren Sie uns
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-273">
            Haben Sie Fragen oder Interesse an einer Demo? Wir helfen Ihnen
            gerne weiter.
          </p>
        </div>
      </section>

      <section className="py-12 bg-[#0a0a0f]" data-id="element-274">
        <div className="container mx-auto px-4 md:px-6" data-id="element-275">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-276">
            {/* Contact Info */}
            <div data-id="element-277">
              <h2 className="text-2xl font-bold text-white mb-8" data-id="element-278">
                Wir sind für Sie da
              </h2>
              <div className="space-y-6 mb-12" data-id="element-279">
                <Card className="flex items-start gap-4 p-6" data-id="element-280">
                  <Mail className="w-6 h-6 text-cyan-400 mt-1" data-id="element-281" />
                  <div data-id="element-282">
                    <h4 className="font-bold text-white" data-id="element-283">E-Mail</h4>
                    <p className="text-gray-400" data-id="element-284">info@tika-mobility.de</p>
                  </div>
                </Card>
                <Card className="flex items-start gap-4 p-6" data-id="element-285">
                  <Phone className="w-6 h-6 text-cyan-400 mt-1" data-id="element-286" />
                  <div data-id="element-287">
                    <h4 className="font-bold text-white" data-id="element-288">Telefon</h4>
                    <p className="text-gray-400" data-id="element-289">+49 40 60 77 685 77</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-290">
                      Mo-Fr, 9:00 - 18:00 Uhr
                    </p>
                  </div>
                </Card>
                <Card className="flex items-start gap-4 p-6" data-id="element-291">
                  <MapPin className="w-6 h-6 text-cyan-400 mt-1" data-id="element-292" />
                  <div data-id="element-293">
                    <h4 className="font-bold text-white" data-id="element-294">Hauptsitz</h4>
                    <p className="text-gray-400" data-id="element-295">
                      PEZULA Projects & Experts GmbH
                      <br data-id="element-296" />
                      Innungsstr. 5<br data-id="element-297" />
                      21244 Hamburg
                    </p>
                  </div>
                </Card>
              </div>
            </div>

            {/* Form */}
            <div data-id="element-298">
              <Card className="p-8" data-id="element-299">
                {isSubmitted ? <div className="text-center py-12" data-id="element-300">
                    <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-301">
                      <CheckCircle className="w-8 h-8 text-green-500" data-id="element-302" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-303">
                      Vielen Dank!
                    </h3>
                    <p className="text-gray-400 mb-8" data-id="element-304">
                      Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns
                      innerhalb von 24-48 Stunden bei Ihnen melden.
                    </p>
                    <Button onClick={() => setIsSubmitted(false)} variant="outline" data-id="element-305">
                      Neue Nachricht senden
                    </Button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-306">
                    <h3 className="text-xl font-bold text-white mb-6" data-id="element-307">
                      Nachricht senden
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-308">
                      <div className="space-y-2" data-id="element-309">
                        <label className="text-sm font-medium text-gray-300" data-id="element-310">
                          Name
                        </label>
                        <input required type="text" className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" placeholder="Max Mustermann" data-id="element-311" />
                      </div>
                      <div className="space-y-2" data-id="element-312">
                        <label className="text-sm font-medium text-gray-300" data-id="element-313">
                          Firma
                        </label>
                        <input type="text" className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" placeholder="Musterfirma GmbH" data-id="element-314" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-315">
                      <div className="space-y-2" data-id="element-316">
                        <label className="text-sm font-medium text-gray-300" data-id="element-317">
                          E-Mail
                        </label>
                        <input required type="email" className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" placeholder="max@beispiel.de" data-id="element-318" />
                      </div>
                      <div className="space-y-2" data-id="element-319">
                        <label className="text-sm font-medium text-gray-300" data-id="element-320">
                          Telefon
                        </label>
                        <input type="tel" className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" placeholder="+49 ..." data-id="element-321" />
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-322">
                      <label className="text-sm font-medium text-gray-300" data-id="element-323">
                        Interesse an
                      </label>
                      <select className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" data-id="element-324">
                        <option data-id="element-325">Privatnutzung</option>
                        <option data-id="element-326">Flottenmanagement</option>
                        <option data-id="element-327">Car Rental / Vermietung</option>
                        <option data-id="element-328">OEM / Partnerschaft</option>
                        <option data-id="element-329">Sonstiges</option>
                      </select>
                    </div>

                    <div className="space-y-2" data-id="element-330">
                      <label className="text-sm font-medium text-gray-300" data-id="element-331">
                        Nachricht
                      </label>
                      <textarea required rows={4} className="w-full bg-gray-950 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 outline-none transition-all" placeholder="Wie können wir Ihnen helfen?" data-id="element-332" />
                    </div>

                    <Button type="submit" variant="primary" className="w-full" isLoading={isLoading} data-id="element-333">
                      Nachricht absenden
                    </Button>
                    <p className="text-xs text-center text-gray-500 mt-4" data-id="element-334">
                      Wir melden uns innerhalb von 24–48 Stunden.
                    </p>
                  </form>}
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>;
}